import { callApiToServer } from "../callApi";

export async function deleteAppContent(
  authtoken,
  staticPageId,
  skipNumber,
  limitNumber,
  searchText
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    let body = JSON.stringify({
      search_text: searchText,
    });

    let endUrl = "v1/auth/admin/delete-static-page/" + staticPageId;

    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "DELETE", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
